import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AnimatedTextInput from "./animatedTextInput";
import { parseNumberFromAnotherLocale } from "../utils";

function Mobile({
  question,
  descriptions = [],
  labelText,
  inputResponseText = "",
  onSubmitHandler,
  isLoading = false,
}) {
  const { t } = useTranslation();
  const [text, setText] = useState(inputResponseText);
  const [isMobileValid, setIsMobileValid] = useState(false);
  const [errorMessage, setErrorMessage] = useState(t("onboard.MOBILE.error"));
  const handleChange = (e) => setText(e.target.value);

  useEffect(() => {
    // Valid mobile values
    // 10 digits, can contain spaces
    // +91XXXXXX9914 - When linking existing profiles created in Receptionist module
    // If the string is in hindi / marathi locale
    try {
      const stripSpaces = text.replace(/\s/g, "");
      if (stripSpaces !== "" && !text.includes("XX")) {
        parseNumberFromAnotherLocale(stripSpaces);
      }
      const isValid =
        stripSpaces.length === 10 || text.includes("XX") || text === "";
      if (!isValid) {
        setErrorMessage(t("onboard.MOBILE.error"));
      }
      setIsMobileValid(isValid);
    } catch (e) {
      setErrorMessage("Unable to parse input");
      setIsMobileValid(false);
    }
  }, [text]);

  const Descriptions = descriptions.map((text, index) => {
    return (
      <p className="desc" key={index}>
        {text}
      </p>
    );
  });

  const processInput = (numericInput) => {
    const stripSpaces = text.replace(/\s/g, "");
    if (stripSpaces !== "" && !text.includes("XX")) {
      return parseNumberFromAnotherLocale(stripSpaces);
    } else {
      return stripSpaces;
    }
  };

  return (
    <div className="body_content">
      <div className="inner_body ">
        <h3 className="headtitle">{question}</h3>
        {Descriptions}
        <div className="fill_form light_fill_form">
          <AnimatedTextInput
            label={labelText}
            value={text}
            isDisabled={text.includes("XX")}
            onChange={handleChange}
            isFocused={true}
          />
          {!isMobileValid && (
            <span className="txt_help " style={{ color: "red" }}>
              {errorMessage}
            </span>
          )}

          <div className="btn_block d-flex justify-content-center bottom_button">
            <button
              className="btn btn_primary nextstep_cta"
              disabled={!text || isLoading || !isMobileValid}
              onClick={() => onSubmitHandler(processInput(text))}
            >
              {isLoading && (
                <span className="icon ml-4 fa-solid fa-spinner fa-spin"></span>
              )}
              &nbsp;{t("sidenav.MOBILE.otp")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Mobile;
